import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';

const CoreUILayout = () => {
	return (
		<>
			<Header />
			<Outlet />
		</>
	);
};

export default CoreUILayout;
